<template>
  <v-layout row wrap>
    <v-flex v-for="(column, index) in columns" :key="index"
            xs12 sm3 :class="columnClass(column)"
    >
      <nx-form-scope-field-generator
        v-for="fieldConfig in column.fields"
        :component="fieldConfig.component"
        :scope="scope"
        :key="fieldConfig.key"
        :label="fieldConfig.label"
        :name="fieldConfig.name"
        :validation="fieldConfig.validation"
        :value="formValue[fieldConfig.name]"
        :form-value="formValue"
        :disable-if="fieldConfig.params.disableIf"
        :disable-if-overwrite-value-with="fieldConfig.params.disableIfOverwriteValueWith"
        :required-if="fieldConfig.params.requiredIf"
        :required-for-publish="fieldConfig.params.requiredForPublish"
        :required-for-publish-if="fieldConfig.params.requiredForPublishIf"
        :required-if-empty="fieldConfig.params.requiredIfEmpty"
        :required-for-publish-if-empty="fieldConfig.params.requiredForPublishIfEmpty"
        :required-for-publish-message="fieldConfig.params.requiredForPublishMessage"
        :not-required-if="fieldConfig.params.notRequiredIf"
        :not-required-if-empty="fieldConfig.params.notRequiredIfEmpty"
        :required-if-any="fieldConfig.params.requiredIfAny"
        :required-if-all="fieldConfig.params.requiredIfAll"
        :heading="fieldConfig.params.heading"
        :valueToDisclaimerMessage="fieldConfig.params.valueToDisclaimerMessage"
        :disclaimerOnModified="fieldConfig.params.disclaimerOnModified"
        :disclaimerIgnoreFieldId="fieldConfig.params.disclaimerIgnoreFieldId"
        :trigger-population="fieldConfig.params.triggerPopulation"
        :use-populate-fields-cms-api-service="fieldConfig.params.usePopulateFieldsCmsApiService"
        :enableIfPermissionAction="fieldConfig.params.enableIfPermissionAction"
        :enableIfPermissionActionEntity="fieldConfig.params.enableIfPermissionActionEntity"
        :enableIfPermissionActionCurrentValue="fieldConfig.params.enableIfPermissionCurrentValue"
        :params="{ ...fieldConfig.params, ...$attrs }"
        @request-population="$emit('request-population', $event)"
        @trigger-population="$emit('trigger-population', { fieldConfig, ...$event })"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import LayoutField from '@/modules/form/mixins/layout-field';
import NxFormScopeFieldGenerator from '@/modules/form/FormScopeFieldGenerator';

export default {
  name: 'nx-form-columns',
  mixins: [LayoutField],
  components: { NxFormScopeFieldGenerator },
  props: {
    formValue: {
      type: Object,
      required: true,
    },
    fieldsConfigFirstColumn: {
      type: Array,
      default: () => ([]),
    },
    fieldsConfigSecondColumn: {
      type: Array,
      default: () => ([]),
    },
    fieldsConfigThirdColumn: {
      type: Array,
      default: () => ([]),
    },
    fieldsConfigFourthColumn: {
      type: Array,
      default: () => ([]),
    },
    scope: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    columns() {
      return [
        {
          fields: this.prepareConfig(this.fieldsConfigFirstColumn),
          class: 'pr-2',
        },
        {
          fields: this.prepareConfig(this.fieldsConfigSecondColumn),
          class: 'px-2',
        },
        {
          fields: this.prepareConfig(this.fieldsConfigThirdColumn),
          class: 'px-2',
        },
        {
          fields: this.prepareConfig(this.fieldsConfigFourthColumn),
          class: 'pl-2',
        },
      ].filter(column => column.fields.length > 0);
    },
  },
};
</script>
